import {
  Button,
  Center,
  Flex,
  Tabs,
  Text,
  useMantineTheme,
} from "@mantine/core";
import ProfileInformation from "./ProfileInformation/Index";
import Financial from "./Financial/Index";
import Password from "./Password/Index";
import { useCallback, useEffect, useState } from "react";
import { ArrowRight2 } from "iconsax-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { client_selected } from "../../client";

const Profile = () => {
  const theme = useMantineTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");
  const [comp, setComp] = useState<React.ReactNode>(<ProfileInformation />);
  const [type, setType] = useState<string>("profile");
  const path = location.pathname;
  const hasFinancial = client_selected.hasFinancial;
  const handleRedirect = useCallback(
    (btn: (typeof contentButtons)[number]) => {
      setType(btn?.id);
      setComp(btn?.component);
      navigate(btn?.path);
    },
    [navigate]
  );

  useEffect(() => {
    if (path.includes("meu-perfil/senha")) {
      setComp(<Password />);
      setType("password");
    } else if (path.includes("meu-perfil/financeiro")) {
      setComp(<Financial />);
      setType("financial");
    } else {
      setComp(<ProfileInformation />);
      setType("profile");
    }
    //eslint-disable-next-line
  }, [location]);

  const contentButtons = [
    {
      id: "profile",
      component: <ProfileInformation />,
      title: t("meu_perfil.content_buttons.profile"),
      text: t("meu_perfil.content_buttons.profile_text"),
      path: "/meu-perfil/configuracoes",
      isActive: true,
    },
    {
      id: "financial",
      component: <Financial />,
      title: t("meu_perfil.content_buttons.financial"),
      text: t("meu_perfil.content_buttons.financial_text"),
      path: "/meu-perfil/financeiro",
      isActive: hasFinancial,
    },
    {
      id: "password",
      component: <Password />,
      title: t("meu_perfil.content_buttons.password"),
      text: t("meu_perfil.content_buttons.password_text"),
      path: "/meu-perfil/senha",
      isActive: true,
    },
  ] as const;
  return (
    <Center h="100%" bg={"other.0"} py={{ base: 24, 991: 32 }}>
      <Flex w="100%" maw={1680} mx={{ base: 24, 770: 60 }}>
        <Flex
          justify="center"
          align="center"
          w="100%"
          direction={{ base: "column", 991: "row" }}
          gap={{ base: 24, 1400: 74 }}
        >
          <Flex
            direction="column"
            maw={{ base: "100%", 999: 396 }}
            h="100%"
            w="100%"
            id="options"
            gap="48px"
          >
            <Flex direction="column" gap="24px">
              <Text
                c="primary.2"
                lh={{ base: "155%" }}
                fz={{ base: 28 }}
                fw={{ base: 700 }}
              >
                {t("meu_perfil.title")}
              </Text>
              <Text c="basic.4" lh={{ base: "155%" }} fz={{ base: 20 }}>
                {t("meu_perfil.description", { name: client_selected.name })}
              </Text>
            </Flex>
            {isLargerThan991 ? (
              <Flex
                id="flexButtonsEditProfile"
                mb="auto"
                gap={16}
                direction="column"
              >
                {contentButtons?.map((btn, index) => {
                  return btn.isActive ? (
                    <Button
                      key={`${btn?.id}-${index}`}
                      onClick={() => {
                        handleRedirect(btn);
                      }}
                      fullWidth
                      bg={btn.id === type ? "primaryOpacity.2" : ""}
                      sx={{
                        border:
                          btn.id === type
                            ? `1px solid ${theme.colors.primary[0]}`
                            : "",
                      }}
                      rightIcon={<ArrowRight2 size={28} />}
                      variant="login"
                      h={88}
                    >
                      {btn?.title}
                      <Text
                        display={{ base: "none", 445: "block" }}
                        component="span"
                      >
                        {btn?.text}
                      </Text>
                    </Button>
                  ) : null;
                })}
                {/* <Button fullWidth variant="danger" mt={32} mb={40}>
                Excluir conta
              </Button> */}
              </Flex>
            ) : (
              <Tabs
                value={type}
                radius="xs"
                defaultValue={type}
                styles={{
                  root: {
                    zIndex: 1,
                    overflowY: isLargerThan991 ? "auto" : "hidden",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                    "::-webkit-scrollbar": {
                      display: "none",
                    },
                  },
                  tabsList: {
                    borderBottom: `1px solid ${theme.colors.basic[2]}`,
                    flexWrap: isLargerThan991 ? "wrap" : "nowrap",
                  },
                }}
              >
                <Tabs.List>
                  {contentButtons.map((btn, index) => {
                    return btn.isActive ? (
                      <Tabs.Tab
                        key={`${btn?.id}-${index}`}
                        onClick={() => {
                          handleRedirect(btn);
                        }}
                        value={btn?.id}
                        color="primary"
                      >
                        {btn?.title}
                      </Tabs.Tab>
                    ) : null;
                  })}
                </Tabs.List>
              </Tabs>
            )}
          </Flex>
          {comp}
        </Flex>
      </Flex>
    </Center>
  );
};

export default Profile;
